import { GET_ADDTAG_REQUESTED, GET_RATING_REQUESTED, GET_TAG_REQUESTED, GET_UPDATETAG_REQUESTED } from "resources/actionTypes";

export function getTag(type) {
  const data ={
    type:type,
  }
  return {
    type: GET_TAG_REQUESTED,
    payload:data
  };
}

export function postAddTag(userAddTag) {
  const data ={
    userAddTag:userAddTag,
  }
  return {
    type: GET_ADDTAG_REQUESTED,
    payload: data,
  };
}

export function postUpdateTag(userUpdateTag) {
  const data ={
    userUpdateTag:userUpdateTag,
  }
  return {
    type: GET_UPDATETAG_REQUESTED,
    payload: data,
  };
}

export function getRating(data) {
  return {
    type: GET_RATING_REQUESTED,
    payload:data
  };
}
